import axios from "axios";

export const useRestrictionCheck = () => {
  const checkRestriction = async (longitude, latitude) => {
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/gis/locations/check-restricted-area`,
        {
          longitude,
          latitude,
        },
      );

      return data.is_restricted;
    } catch (error) {
      console.error("Error checking restricted area:", error);
      return false;
    }
  };

  return {
    checkRestriction,
  };
};
